import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Avatar, Icon, Tag } from 'antd';
import { Link } from 'react-router-dom';
import Tab from '../Tab';
import Layout from '../Layout';
import ErrorAlert from '../../components/ErrorAlert';
import { get, resetState, remove } from '../../modules/reports';

class ReportsTab extends Tab {
  columns = [
    { key: 'id', title: 'ID', dataIndex: 'id' },
    {
      key: 'type',
      title: 'Type',
      dataIndex: 'type',
      render: (name, data) => <Tag color="orange">{data.type}</Tag>,
    }, {
      key: 'place',
      title: 'Place',
      dataIndex: 'place',
      render: (name, data) => {
        return (
          <Fragment>
            <Avatar
              size="large"
              src={data.place.logo}
              className="mr-1"
            />
            <span>{data.place.name}</span>
          </Fragment>
        );
      },
    }, {
      key: 'details',
      title: 'Ditails',
      dataIndex: 'details',
      render: (name, data) =>
        <Link to={`/reports/${data.id}`}>Details</Link>,
    },
    this.tableActions(),
  ];

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error} />
        <div className="container">
          <Row>
            <Col>
              {this.renderDataTable()}
            </Col>
          </Row>
        </div>
      </Layout>
    );
  }
}

export default connect(state => state.reports, { get, resetState, remove })(ReportsTab);



// WEBPACK FOOTER //
// ./src/containers/Reports/ReportsTab.js